export default __webpack_public_path__ + "static/media/TheGlobalMerchants.7756207b.png";